var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 1.17603L6.875 4.17603C7.09375 4.67603 6.96875 5.26978 6.53125 5.61353L5 6.89478C6.03125 9.08228 7.8125 10.8635 10 11.8948L11.2812 10.3635C11.625 9.92603 12.2188 9.80103 12.7188 10.0198L15.7188 11.2698C16.3125 11.4885 16.5938 12.1448 16.4375 12.7385L15.6875 15.4885C15.5312 16.0198 15.0625 16.3948 14.5 16.3948C6.75 16.3948 0.5 10.1448 0.5 2.39478C0.5 1.83228 0.875 1.36353 1.40625 1.20728L4.15625 0.457275C4.75 0.301025 5.40625 0.582275 5.625 1.17603Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0918c38f098b20039bc163048254e77d.svg";
export { ForwardRef as ReactComponent };